import { gql } from '@apollo/client';

export const REMOVE_RFID_TOKEN = gql`
  mutation DeleteRfidToken($input: DeleteRfidTokenInput!) {
    deleteRfidToken(input: $input) {
      serialNumber
    }
  }
`;
